import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export function initAnimation() {
  // Register plugins
  gsap.registerPlugin(ScrollTrigger);

  // GSAP defaults
  gsap.defaults({
    ease: 'power1.inOut',
  });

  // ScrollTrigger defaults
  ScrollTrigger.defaults({
    // markers: true,
    fastScrollEnd: 100,
  });
}

function getScrollTriggerPosition() {
  const sectionHeight = getComputedStyle(document.documentElement).getPropertyValue("--section-height").trim();
  return {
    start: `50% 100%`,
    end: `50% 0%`,
  };
}

export const scrolling = {
    enabled: true,
    events: "scroll,wheel,touchmove,pointermove".split(","),
    prevent: e => e.preventDefault(),
    disable() {
      if (scrolling.enabled) {
        //scrolling.enabled = false;
        //window.addEventListener("scroll", gsap.ticker.tick, {passive: true});
        //scrolling.events.forEach((e, i) => (i ? document : window).addEventListener(e, scrolling.prevent, {passive: false}));
        //document.querySelector('html').style.overflow = 'hidden';
      }
    },
    enable() {
      if (!scrolling.enabled) {
        //scrolling.enabled = true;
        //window.removeEventListener("scroll", gsap.ticker.tick);
        //scrolling.events.forEach((e, i) => (i ? document : window).removeEventListener(e, scrolling.prevent));
        //document.querySelector('html').style.overflow = 'auto';
      }
    }
  };

// Shared config for sections: Video, Info, Showcase, Contact
export const scrollTriggerConfig = {
  start: getScrollTriggerPosition().start,
  end: getScrollTriggerPosition().end,
  toggleClass: 'section--active'
};

export const duration = {
  intro: 0.75,
  feature: 0.75,
  video: 0.75,
  info: 0.75,
  showcase: 0.75,
  contact: 0.75,
};
